// extracted by mini-css-extract-plugin
module.exports = {"root":"features_root__2lco_","doodleBackground":"features_doodleBackground__1xUSq"};